import * as React from "react";
import { Text } from "components/text";
import { cn } from "utils";

export interface BasePanelProps {
  title?: string;
  headerClassName?: string;
  contentClassName?: string;
  className?: string;
  headerAction?: React.ReactNode;
  footer?: React.ReactNode;
  isEmpty?: boolean;
  emptyComponent?: React.ReactNode;
  children?: React.ReactNode;
  border?: boolean;
  wrapper?: boolean;
  ref?: React.Ref<HTMLDivElement>;
  testId?: string;
}

export const BasePanel = ({
  title,
  headerClassName,
  contentClassName,
  className,
  headerAction,
  footer,
  isEmpty,
  emptyComponent,
  children,
  border = true,
  wrapper = true,
  ref,
  testId,
}: BasePanelProps) => {
  return (
    <div
      ref={ref}
      data-testid={testId}
      className={cn(
        "flex flex-col w-full overflow-hidden",
        border && "rounded-xl border border-secondary-200",
        className,
      )}
    >
      {title || headerAction ? (
        <div
          className={cn(
            "flex shrink-0 items-center justify-between h-12 px-5 bg-secondary-50",
            headerClassName,
          )}
        >
          <Text variant="label">{title}</Text>
          {headerAction}
        </div>
      ) : null}

      {isEmpty ? (
        <div className={cn("flex-1 overflow-y-auto", contentClassName)}>
          {emptyComponent}
        </div>
      ) : null}

      {!isEmpty && !wrapper ? children : null}

      {!isEmpty && wrapper ? (
        <div className={cn("flex-1 overflow-y-auto", contentClassName)}>
          <div className="grid grid-cols-1">{children}</div>
        </div>
      ) : null}

      {footer}
    </div>
  );
};
